export const InstagramIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 23 23" {...props}>
			<use href="/images/icons.svg#vlw-instagram" />
		</svg>
	)
}
